angular.module('app')
  .directive('mediathequeLotInput', LotInputDirective);

function LotInputDirective() {
  return {
    restrict: 'E',
    scope: {
      name: '@mediathequeName',
      id: '@mediathequeId',
      form: '@mediathequeForm',
      placeholder: '@mediathequePlaceholder',
      disabled: '&mediathequeDisabled',
      onChange: '&mediathequeOnChange',
      model: '=ngModel',
      typeLot: '@mediathequeTypeLot',
      initialValue: '&mediathequeInitialValue',
      applyFocus: '&mediathequeApplyFocus'
    },
    replace: true,
    controller: LotInputController,
    controllerAs: 'inputCtrl',
    templateUrl: 'common/lot-input.html'
  };
}

/*@ngInject*/
function LotInputController($scope, LotSuggest) {
  var inputCtrl = this;

  inputCtrl.getSuggestions = getSuggestions;
  inputCtrl.hasValidValue = hasValidValue;
  inputCtrl.onChange = $scope.onChange;

  init();

  // TODO: Ajouter un watcher sur $scope.model (couplé à un $timeout pour s'assurer que le scope est bien à jour)
  // si le model initial est modifié par le composant parent

  function init() {
    if ($scope.model) {
      return;
    }
    $scope.model = $scope.initialValue() || { libelle: "" };
  }

  function hasValidValue() {
    if ($scope.model === '') {
      return true;
    }
    if ($scope.model.id) {
      return true;
    }
    return $scope.model.libelle === '' || $scope.model.libelle === null;
  }

  inputCtrl.loading = false;
  function getSuggestions(currentValue) {
    if ($scope.disabled()) {
      return;
    }
    inputCtrl.loading = true;
    return LotSuggest.search($scope.typeLot, currentValue)
      .then((result) => {
        inputCtrl.loading = false;
        return result.data;
      });
  }
}
